import * as S from "./FormInputBox.style";

interface FormInputProps {
  children?: React.ReactNode;
  formTitle?: string;
}

export const FormInputBox = ({ formTitle, children }: FormInputProps) => {
  return (
    <S.FormInputBox>
      {formTitle && (
        <S.FormInputTitle>
          {formTitle}
          <span>* 표시는 필수 입력 입니다.</span>
        </S.FormInputTitle>
      )}
      <S.FormInputContent>{children}</S.FormInputContent>
    </S.FormInputBox>
  );
};
